import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const OutOfBoundsIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <g clipPath="url(#clip0_10516_34747)">
            <path
               d="M12.7969 0.330436C12.3562 -0.110145 11.6438 -0.110145 11.2078 0.330436L5.95312 5.57992C5.5125 6.02051 5.5125 6.73294 5.95312 7.16883C6.39375 7.60473 7.10625 7.60941 7.54219 7.16883L10.8703 3.84103V15.3758C10.8703 15.9992 11.3719 16.5007 11.9953 16.5007C12.6187 16.5007 13.1203 15.9992 13.1203 15.3758V3.84103L16.4484 7.16883C16.8891 7.60941 17.6016 7.60941 18.0375 7.16883C18.4734 6.72825 18.4781 6.01582 18.0375 5.57992L12.7969 0.330436ZM3.375 1.5022C1.50938 1.5022 0 3.01143 0 4.87687V20.6253C0 22.4908 1.50938 24 3.375 24H20.625C22.4906 24 24 22.4908 24 20.6253V4.87687C24 3.01143 22.4906 1.5022 20.625 1.5022H20.25C19.6266 1.5022 19.125 2.00371 19.125 2.62709C19.125 3.25046 19.6266 3.75198 20.25 3.75198H20.625C21.2484 3.75198 21.75 4.25349 21.75 4.87687V20.6253C21.75 21.2487 21.2484 21.7502 20.625 21.7502H3.375C2.75156 21.7502 2.25 21.2487 2.25 20.6253V4.87687C2.25 4.25349 2.75156 3.75198 3.375 3.75198H3.75C4.37344 3.75198 4.875 3.25046 4.875 2.62709C4.875 2.00371 4.37344 1.5022 3.75 1.5022H3.375Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_10516_34747">
               <rect
                  width="24"
                  height="24"
                  fill="white"
               />
            </clipPath>
         </defs>
      </svg>
   )
}

export default OutOfBoundsIcon
